import { render, staticRenderFns } from "./step2b.vue?vue&type=template&id=2ce50e98"
import script from "./step2b.vue?vue&type=script&lang=js"
export * from "./step2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports